import { getEnvBoolean } from '@egr/xbox/utils/ReactScriptHelper';
import { android } from '@egr/xbox/utils/UserAgent';

export interface ReactNativeApp {ReactNativeWebView?: {postMessage: (data: string) => void}}
export const isReactNativeApp: boolean = (window as ReactNativeApp).ReactNativeWebView?.postMessage != null;
export const isAndroidApp: boolean = isReactNativeApp && android;
export const DEBUG_FAKE_APP: boolean = getEnvBoolean('DEBUG_FAKE_APP', false);